import { useEffect, useState } from "react";

export default function useTabsAndLinks({
  recordsSets,
  populationFilterIndex,
  populationSelectedItem,
  searchKey,
}) {
  const [tabs, setTabs] = useState([]);
  const [linksSets, setLinksSets] = useState([]);

  useEffect(() => {
    let filteredSets;
    if (!populationFilterIndex && !searchKey?.length) {
      filteredSets = recordsSets;
    } else {
      if (searchKey?.length) {
        filteredSets = recordsSets
          .map((el) => ({
            ...el,
            list: el.list.filter((item) =>
              item.title.toLowerCase().includes(searchKey.toLowerCase())
            ),
          }))
          .filter(({ list }) => !!list.length);
      }
      if (populationFilterIndex) {
        const setsToFilter = searchKey?.length ? filteredSets : recordsSets;
        filteredSets =
          setsToFilter && setsToFilter.length
            ? setsToFilter
                .map((el) => ({
                  ...el,
                  // We will dig into the list array and filter based on population type selected in the dropdown
                  list: el.list.filter(
                    (item) =>
                      item.population?.some(
                        (value) =>
                          value.toLowerCase() ===
                          populationSelectedItem.toLowerCase()
                      ) ||
                      item.population?.some(
                        (value) => value.toLowerCase() === "all"
                      )
                  ),
                }))
                .filter(({ list }) => !!list.length)
            : filteredSets;
      }
    }

    const createdTabs =
      filteredSets && filteredSets.length
        ? filteredSets.map(({ char, id, isActive }) => ({
            char,
            id,
            isActive,
          }))
        : filteredSets;

    const createdLinksSets =
      filteredSets && filteredSets.length
        ? filteredSets.map(({ char, list }) => ({
            char,
            list,
          }))
        : filteredSets;

    setTabs(createdTabs);
    setLinksSets(createdLinksSets);
  }, [recordsSets, populationFilterIndex, populationSelectedItem, searchKey]);

  return {
    tabs,
    linksSets,
  };
}
